import React, { useContext, useEffect, useRef, useState } from 'react'
import classes from './FavoritePopup.module.css'
import { useDispatch, useSelector } from 'react-redux';
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";


import axios from 'axios';
import { Button, Checkbox, Form, Input } from 'antd';
import { useNavigate } from '@hooks/useNavigate';
import AuthContext from '../authContext';

const style = {
  position: "absolute",
  top: "50%", 
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "fit-content",
  bgcolor: "background.paper",
  border: "2px solid #ACACAC",
  borderRadius: "1em",
  boxShadow: 24,
  p: 4,
};

const FavoritePopup = ({carttoggle}) => {
  const [isalertOpen, setalertOpen] = React.useState(false);
  const navigate = useNavigate(); 
  const [form] = Form.useForm();
  const [categories, setcategories] = useState([]);
  const [selectedCategory, setselectedCategory] = useState({});
  const authCtx = useContext(AuthContext)
  const language = useSelector((state) => state.products.selectedLanguage[0].Language);
  const userInfo = useSelector((state) => state.products.userInfo);
  const getToken = () => {
    return sessionStorage.getItem("token");
  };

  const token = getToken();
 
  const dispatch = useDispatch()
    const favoriteData = useSelector((state) => state.products.favorites);
    const [filteredFavoriteData, setFilteredFavoriteData] = useState(favoriteData);
    
    const fetchcategories = async () => {
      try {
        const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/users/${userInfo.id}/favorite-category`, {
          headers: {
              Authorization: `Bearer ${token}` // Include token in the headers
          }
      });
      
        setcategories(response.data.data);
        setselectedCategory(response.data.data[0])
      } catch (error) {
        // console.error('Error fetching fav categories:', error);
      }
    };
    useEffect(() => {
      fetchcategories();
    }, [authCtx.favPopup]);
    
    const [showPopup, setShowPopup] = useState(false);

    const onFinish = async () => {
        authCtx.addToFavoriteWithCatigory(selectedCategory.id );
    };

  return (
      <Modal
        open={authCtx.favPopup}
        onClose={() => authCtx.setFavPopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{ overflow: "hidden" }}
      >
        <Box sx={style}>
        <div className={classes.header} style={{marginBottom:'2em'}}>
          <div className={classes.title} style={{minWidth:'40vw',marginBottom:'.5em'}}>
            <h1>Ajouter à une liste</h1>
          </div>
        </div>
          {categories?.length === 0 ? <div>
            <h3 className={classes.emptycat}>les catégories de votre liste de souhaits sont vides veuillez ajouter des catégories avant d'ajouter l'article à la liste de souhaits</h3>
        <div style={{display:'flex',flexWrap:'wrap' ,width:'fit-content',margin:'2em auto 0 auto ',gap:'1em'}}>
        <Button 
           size="large"
           style={{
             cursor: 'pointer',
             backgroundColor:'var(--secondary-color)',marginBottom:'0'
           }} onClick={()=>authCtx.setFavPopup(false)}
           className={classes.browseBtn }>
           {language === "eng" ? "Cancel" : "Annuler "}
          </Button>
        <Form.Item className={classes.formItem}>
        <Button 
           size="large"
            style={{marginBottom:'0'}}
            onClick={()=>navigate(`/wishlist`)& authCtx.setFavPopup(false)}
           className={classes.browseBtn }> 
            {language === "eng" ? "Add" : "Ajouter "}
          </Button>
        </Form.Item>
        </div> 
          </div> : 
          <Form 
              layout="vertical"
              name="nest-messages"
              className={classes.form}
              onFinish={onFinish}
              form={form}
    >
       <div className={classes.btnsCont}>
        {categories?.map((item, index) => {
            return (
                <button key={index} onClick={(e)=>{
                    e.preventDefault();
                    e.stopPropagation()
                  setselectedCategory(item)}} style={{opacity:item.id === selectedCategory.id ? '1' : '.5'}}>
                  { item?.name}
                </button>
            );
        })}
      </div>
      <div style={{display:'flex',flexWrap:'wrap' ,width:'fit-content',margin:'2em auto 0 auto ',gap:'1em'}}>
      <Button 
           size="large"
           style={{
             cursor: 'pointer',
             backgroundColor:'#fff',marginBottom:'0'
           }} onClick={()=>authCtx.setFavPopup(false)}
           className={classes.browseBtn }>
           {language === "eng" ? "Cancel" : "Annuler "}
          </Button>
        <Form.Item className={classes.formItem}>
        <Button 
           size="large"
           htmlType="submit" style={{marginBottom:'0'}}
          //  disabled = {addloading ? true : false} 
           className={classes.browseBtn }> 
            {language === "eng" ? "Add" : "Ajouter"}
          </Button>
        </Form.Item>
        </div> 
    </Form>}
        </Box>
      </Modal>
  )
}

export default FavoritePopup